import { searchObjectsByAttribute } from '../utils/index'
import { Response } from 'miragejs'

export default function routes () {
  const restPrefix = process.env.MOCK_REST_URL_SUFIX
  this.urlPrefix = process.env.MOCK_BASE_APIS_URL
  this.timing = 3000

  this.get(`${restPrefix}/engagement/campaigns`, (schema, request) => {
    const route_path = `${this.urlPrefix}/engagement/campaigns`
    const { queryParams: { page = 1, limit = 5, title } } = request

    let campaigns = schema.db.campaigns
    campaigns = title ? searchObjectsByAttribute(campaigns, 'title', title) : campaigns || []

    const start = Number(limit) * (Number(page) - 1)
    const end = start + Number(limit)
    const pageItems = campaigns.slice(start, end)

    const from = campaigns.length ? start + 1 : 0
    const to = ((Number(page) - 1) * limit) + pageItems.length
    const last_page = parseInt(campaigns.length / Number(limit)) + 1

    return {
      data: pageItems,
      links: {
        first: `${route_path}?page=1`,
        last: `${route_path}?page=${last_page}`,
        prev: null,
        next: null
      },
      meta: {
        current_page: Number(page),
        from,
        last_page,
        path: route_path,
        per_page: Number(limit),
        to,
        total: campaigns ? campaigns.length : 0
      }
    }
  })

  this.get(`${restPrefix}/partners/engagement/`, (schema, request) => {
    const route_path = `${this.urlPrefix}/partners/engagement/`
    const { queryParams: { page = 1, limit = 5, slug } } = request

    let partners = schema.db.partners
    partners = slug ? searchObjectsByAttribute(partners, 'slug', slug) : partners || []

    const start = Number(limit) * (Number(page) - 1)
    const end = start + Number(limit)
    const pageItems = partners.slice(start, end)

    const from = partners.length ? start + 1 : 0
    const to = ((Number(page) - 1) * limit) + pageItems.length
    const last_page = parseInt(partners.length / Number(limit)) + 1

    return {
      data: pageItems,
      links: {
        first: `${route_path}?page=1`,
        last: `${route_path}?page=${last_page}`,
        prev: null,
        next: null
      },
      meta: {
        current_page: Number(page),
        from,
        last_page,
        path: route_path,
        per_page: Number(limit),
        to,
        total: partners ? partners.length : 0
      }
    }
  })
  this.get(`${restPrefix}/partners/engagement?slug=:slug`, (schema, request) => {
    const partners = schema.db.partners
    return partners[0]
  })
  this.get(`${restPrefix}/engagement/coin`, (schema, request) => {
    const coin = schema.db.coins
    console.log('coin', coin[0])
    return coin[0]
  })

  this.passthrough(`${this.urlPrefix}/**`)
}



// WEBPACK FOOTER //
// ./src/mocks/routes/index.js